import { ConfigContext } from "@contexts";
import { useContext } from "react";

export const useConfig = () => {
    return useContext(ConfigContext);
}